import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Select } from 'next/components/ui';
import { SegmentsShape } from 'next/entities/rules';

import { ConditionsContext } from './ConditionsContext';
import { Clause } from './styled';

const NEGATED_OPTIONS = [
  { label: 'matches', value: false },
  { label: "doesn't match", value: true },
];

export const SegmentsClause = ({
  conditions,
  negated,
  onChange,
  onChangeNegated,
}) => {
  const {
    segments: { segment },
  } = conditions;

  const { segmentOptions } = useContext(ConditionsContext);

  const handleChange = ({ value: newSegment }) => {
    onChange({ segments: { ...conditions.segments, segment: newSegment } });
  };

  const options = [...segmentOptions];

  if (
    segment &&
    !options.some(({ value: segmentId }) => segmentId === segment)
  ) {
    options.push({ label: segment, value: segment });
  }

  return (
    <Clause>
      <Select
        value={options.find(
          ({ value: optionSegment }) => optionSegment === segment
        )}
        options={options}
        onChange={handleChange}
        portal
      />
      <Select
        value={negated ? NEGATED_OPTIONS[1] : NEGATED_OPTIONS[0]}
        options={NEGATED_OPTIONS}
        onChange={({ value: isNegated }) => void onChangeNegated(isNegated)}
        portal
      />
    </Clause>
  );
};

SegmentsClause.propTypes = {
  conditions: PropTypes.oneOfType([
    SegmentsShape,
    PropTypes.exact({ not: PropTypes.arrayOf(SegmentsShape) }),
  ]),
  negated: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeNegated: PropTypes.func,
};
